const TipoDeDoc = {
    DNI: "DNI",
    PASSPORT: "PASS",
    PERMISO_TEMP_PERM: "PTP",
    CARNET_EXT: "CE",
};

const TipoDeAsociado = {
    DocId: "DocId",
    RUC: "RUC",
};

const Sexo = {
    Masculino: "M",
    Femenino: "F",
    SinDef: "",
};

export {TipoDeDoc, TipoDeAsociado, Sexo};
